import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";
import { RecaptchaService as recaptcha } from "../Services/RecaptchaService";

const devoCardTemplate = 'DevoCard';
const devoSignUpTemplate = 'DevoSignUp';
const devoSignUpModalTemplate = 'DevoSignUpModal';
const devoUnsubscribeTemplate = 'DevoUnsubscribeModal';

export class DevoModule {
    static async Init() {
        DEBUG && console.info('*--> Events Module Init');

        var elements = document.querySelectorAll('[data-component="devoCard"]');

        elements.forEach(element => {

            var topLevelFolder = element.getAttribute('data-topLevelFolder');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Top Level Folder:        ${topLevelFolder}`);
            DEBUG && console.info('**************************************************');

            this.InitDevoCard(element, topLevelFolder);
        });
    }

    static async InitSignUp() {
        DEBUG && console.info('*--> Devo Signup Init');

        var elements = document.querySelectorAll('[data-component="DevoSignUp"]');

        elements.forEach(element => {

            var didUnsubscribe = element.getAttribute('data-unsubscribe');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Unsubscribed:            ${didUnsubscribe}`);
            DEBUG && console.info('**************************************************');

            this.InitDevoSignUp(element, didUnsubscribe);

            // Check URL query parameters for openDevoSignUp=true
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('openDevoSignUp') === 'true') {
                DEBUG && console.info('Opening Devo signup modal from query parameter');
                this.OpenSignUpModal();
            }
        });
    }

    static async InitDevoSignUp(element, didUnsubscribe) {
        // Init System Modal Here
        var data = {};

        var content = await TemplateService.GetRenderedTemplate(devoSignUpTemplate, data);

        element.innerHTML = content;

        const button = document.getElementById("btnDevoSignUp");

        // Add Event Handler
        button.addEventListener('click', () => {
            console.log('Opening Devo SignUp Modal');

            this.OpenSignUpModal();
        })

        if (didUnsubscribe == 'True') {            
            const baseModal = document.getElementById("baseModal");

            var modalContent = await TemplateService.GetRenderedTemplate(devoUnsubscribeTemplate, data);
            baseModal.innerHTML = modalContent;

            util.openModal(baseModal.id);
        }
    }

    static async OpenSignUpModal() {
        // Add self
        let self = this;

        // Enumerate Elements
        const baseModal = document.getElementById("baseModal");
        
        var modalContent = await TemplateService.GetRenderedTemplate(devoSignUpModalTemplate, null);
        baseModal.innerHTML = modalContent;

        util.openModal(baseModal.id);

        // Setup form 
        // Wire Up Form Elements
        var formElement = document.getElementById('formDevoSignUp');

        // Setup Form
        util.formSetup(formElement);

        formElement.addEventListener('submit', function (event) {

            event.preventDefault();
            event.stopPropagation();

            // Check overall form validity including textareas
            if (!formElement.checkValidity()) {
                console.info("*** => Form INVALID");
                formElement.classList.add('was-validated');
                return;
            } else {
                console.info("*** => Form Valid / Submitting");
                // Perform your form submission logic here
                var formData = util.getFormDataObject(formElement);
                DEBUG && console.info(formData);

                self.SendDevoInvite(formData);
            }

            formElement.classList.add('was-validated');

        }, false);
    }

    static async SendDevoInvite(formData) {
        // Post the Data to the API
        try {
            var token = await recaptcha.getGoogleRecaptchaToken(siteKey, "devoSignUp");

            // Append the callingUrl to the data payload
            formData.callingUrl = window.location.href.split('?')[0];

            var results = await api.postApiDataAsync('Devo/DevoSignUp', formData, token, false, false, false);
            util.showSuccessToast('Check your email for a confirmation.', 8000, true);
            util.closeModal('baseModal');
        } catch (error) {
            util.showErrorToast('An error occurred while finishing your sign up.', 8000, true);
            console.error(error);
        }   
    }

    static async InitDevoCard(element, topLevelFolder) {
        var data = await this.GetLatestDevo();

        var spanishMode = false;
        if (topLevelFolder.toLowerCase() == 'espanol') {
            spanishMode = true;
        }

        var devoData = { "data": data, "topLevelFolder": `${topLevelFolder}`, "spanishMode": spanishMode };

        var content = await TemplateService.GetRenderedTemplate(devoCardTemplate, devoData);

        element.innerHTML = content;
    }


    static async GetLatestDevo() {
        var data = await api.getData(`Devo/GetLatestDevo`);
        DEBUG && console.info(data);
        return data;
    }

}